import './PayConfirmSheet.sass';

import React, { FC, useEffect, useRef } from 'react';
import { useTranslator } from '$hooks';
import { useDispatch, useSelector } from 'react-redux';
import { classNames as cn } from '$utils';
import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { payActions, paySelector } from '$store/pay';
import { PayConfirmSheetProps } from './PayConfirmSheet.interface';

export const PayConfirmSheetInner: FC<PayConfirmSheetProps> = ({ url }) => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const pay = useSelector(paySelector);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      try {
        const contentWindow = iframeRef.current?.contentWindow;
        if (
          contentWindow &&
          [window.location.hostname, 'ton.place'].includes(
            contentWindow.location.hostname,
          )
        ) {
          dispatch(payActions.setPayConfirmUrl(''));
          // dispatch(toastActions.setToastLoading());
          clearInterval(interval);
        }
      } catch (e) {}
    }, 100);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <BottomSheet
      className={cn('PayConfirmSheet', {
        failed: pay.isFailed,
      })}
      title={t('pay_confirm_sheet_title')} // TODO: add link
      onClose={() => {
        dispatch(payActions.setPayConfirmUrl(''));
      }}
    >
      <iframe ref={iframeRef} src={url} className="PayConfirmSheet__iframe" />
    </BottomSheet>
  );
};

export const PayConfirmSheet: FC = () => {
  const { payConfirmUrl } = useSelector(paySelector);

  if (!payConfirmUrl) {
    return null;
  }

  return <PayConfirmSheetInner url={payConfirmUrl} />;
};
